import type { Field, VariableADTvalue } from '@lighthouse/core'
import { useAtomData, VariableSelect } from '@lighthouse/shared'
import React, { useCallback } from 'react'

import { lastPageOfStackAtom } from '@/atoms/page/state'
import { useGetPageParameterAndVariableOptions, useGetUserRecordOptions } from '@/hooks/usePage'
import { useVariableCustomViewOption } from '@/hooks/useVariableCustomViewOption'

interface IframeInputProps {
    value?: VariableADTvalue
    placeholder?: string
    onChange: (val: VariableADTvalue) => void
}

const field: Field = { id: '', type: 'url', innerType: 'TEXT', name: '网页链接', dsId: '' }

export const IframeInput: React.FC<IframeInputProps> = ({ value, placeholder, onChange }) => {
    const pageId = useAtomData(
        lastPageOfStackAtom,
        useCallback(s => s?.pageId || '', [])
    )
    const { customViewOption } = useVariableCustomViewOption()
    const pageOptions = useGetPageParameterAndVariableOptions({ pageId })
    const userOption = useGetUserRecordOptions()
    // const [status, setStatus] = useState(!!value)
    // const inputRef = useRef<HTMLInputElement>(null)
    // const [val, setVal] = useState(value)

    // const handleChange = useCallback((ev: React.ChangeEvent<HTMLInputElement>) => {
    //     setVal(ev.target.value)
    // }, [])

    // const handleOk = useCallback(() => {
    //     if (status) {
    //         setStatus(false)
    //         return requestAnimationFrame(() => {
    //             inputRef.current?.focus()
    //         })
    //     }
    //     setStatus(true)
    //     onChange(val)
    // }, [onChange, status, val])

    return (
        <VariableSelect
            innerTypes={[field.innerType]}
            style={{ flex: 1 }}
            width="100%"
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            field={field}
            disablePexels
            viewOptions={customViewOption ? [customViewOption] : undefined}
            pageOptions={pageOptions}
            userOption={userOption}
        />
    )
}
